"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DojoGaugeCondition = void 0;
/**
 * The condition required for clearing a gauge in a dojo course. Defaults to
 * Percentage.
 */
class DojoGaugeCondition {
    constructor(id) {
        this._id = id;
    }
    static fromId(id, strict = true) {
        const item = DojoGaugeCondition._values.find((it) => it._id === id);
        if (item) {
            return item;
        }
        if (strict) {
            throw new Error(`Invalid DojoGaugeCondition id: ${id}`);
        }
    }
    static fromRaw(raw, strict = true) {
        return DojoGaugeCondition.fromId(raw, strict);
    }
    toString() {
        return this._id;
    }
}
exports.DojoGaugeCondition = DojoGaugeCondition;
DojoGaugeCondition.Percentage = new DojoGaugeCondition('g');
DojoGaugeCondition.GoodAmount = new DojoGaugeCondition('jp');
DojoGaugeCondition.OKAmount = new DojoGaugeCondition('jg');
DojoGaugeCondition.BadAmount = new DojoGaugeCondition('jb');
DojoGaugeCondition.Score = new DojoGaugeCondition('s');
DojoGaugeCondition.Drumroll = new DojoGaugeCondition('r');
DojoGaugeCondition.CorrectHits = new DojoGaugeCondition('h');
DojoGaugeCondition.MaxCombo = new DojoGaugeCondition('c');
DojoGaugeCondition._values = [
    DojoGaugeCondition.Percentage,
    DojoGaugeCondition.GoodAmount,
    DojoGaugeCondition.OKAmount,
    DojoGaugeCondition.BadAmount,
    DojoGaugeCondition.Score,
    DojoGaugeCondition.Drumroll,
    DojoGaugeCondition.CorrectHits,
    DojoGaugeCondition.MaxCombo,
];
